// extracted by mini-css-extract-plugin
export var subtitle = "_at-2";
export var title = "_at-0";
export var titleNoWrap = "_at-1";